import { Center, Flex } from "styled-system/jsx";
import { Tools } from "iconoir-react";
import { useTranslation } from "react-i18next";
import { Heading, Icon, Text } from "@ttc3k/trekker";
import { Multilingual } from "gql/generated.ts";
import { getMultilingualString } from "shared/utils";

export const MaintenancePage = ({ message }: { message: Multilingual }) => {
  const { t } = useTranslation("core", { keyPrefix: "MAINTENANCE_PAGE" });
  return (
    <Center bg={"bg.wa.lightest"} w={"full"} h={"full"} p={"1000"}>
      <Center maxW={"600px"} gap={"400"} flexDir={"column"}>
        <Icon
          Element={Tools}
          w={"60px"}
          h={"60px"}
          color={"icon.warning.mid"}
        />
        <Flex flexDir={"column"} gap={"150"} alignItems={"center"}>
          <Heading size={"h4"}>{t("TITLE")}</Heading>
          <Text visual={"bodyMedium"} color={"text.mid"} textAlign={"center"}>
            {getMultilingualString(message)}
          </Text>
        </Flex>
      </Center>
    </Center>
  );
};
